module.exports = __webpack_public_path__ + "static/media/dish16.ecea00fd.jpg";